import { render, staticRenderFns } from "./ChatAssistant.vue?vue&type=template&id=4656ed84&scoped=true&"
import script from "./ChatAssistant.ts?vue&type=script&lang=ts&"
export * from "./ChatAssistant.ts?vue&type=script&lang=ts&"
import style0 from "./ChatAssistant.scss?vue&type=style&index=0&id=4656ed84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4656ed84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VIcon,VImg,VTextField})
